import React, { useRef } from "react";
import { FaSearch } from "react-icons/fa";
import "./ExpandingSearch.css";

function ExpandingSearch(props) {
  const {
    infoSource,
    handleChange,
    setIsFocused,
    search = "",
    expanded,
    setExpanded,
    wrapperStyle,
    inputStyle,
    placeholderColor,
    alwaysExpanded = false,
    collapseOnMobile = false,
    placeholder: placeholderOverride,
  } = props;

  const inputRef = useRef(null);

  const handleBlur = () => {
    if (!alwaysExpanded && !inputRef.current?.value) {
      setExpanded?.(false);
    }
    setIsFocused?.(false);
  };

  const isExpanded =
    alwaysExpanded ||
    (!collapseOnMobile && !infoSource?.headShop) ||
    expanded;
  const placeholder = placeholderOverride ||
    infoSource?.laguangeElakay?.(
      "frontElakayHardcodedText",
      infoSource.languageAPI
    )?.expandingSearchExpandingSearch?.t001 || "Rechercher un produit";

  return (
    <div
      className={`exp-search-wrapper ${isExpanded ? "expanded" : ""} ${alwaysExpanded ? "always-expanded" : ""}`}
      style={{ ...(wrapperStyle || {}), ...(placeholderColor ? { "--exp-placeholder": placeholderColor } : {}) }}
    >
      <input
        ref={inputRef}
        onChange={handleChange}
        type="search"
        className="exp-input"
        style={inputStyle || {}}
        placeholder={placeholder}
        aria-label={placeholder}
        value={search || ""}
        onBlur={handleBlur}
        onFocus={() => {
          setExpanded?.(true);
          setIsFocused?.(true);
        }}
      />
      <button
        type="button"
        className="exp-search-icon"
        aria-label={placeholder}
        aria-expanded={Boolean(isExpanded)}
        onClick={() => {
          setExpanded?.(true);
          requestAnimationFrame(() => inputRef.current?.focus());
        }}
      >
        <FaSearch />
      </button>
    </div>
  );
}

export default ExpandingSearch;
